import React from "react"
import { colors } from "../Styles"

// #region | Field Style
/* eslint-disable */
export enum NewFieldStyles {
    greyTertiary = "greyTertiary",
    greyLightSecondary = "greyLightSecondary",
    greyDarkSecondary = "greyDarkSecondary",
    greyDarkPrimary = "greyDarkPrimary",
    greySecondary = "greySecondary",
    blueDarkSecondary = "blueDarkSecondary",
    transparent="transparent",
  }
/* eslint-enable */
  
export const CreateNewFieldStyle = (fieldStyle?: NewFieldStyles|string) => {
  let fontColor: colors
  let headerColor: colors
  let primaryColor: colors
  let secondaryColor: colors

  switch (fieldStyle) {
    case 'greyTertiary':
      fontColor = colors.greyDarkPrimary
      headerColor = colors.greyPrimary
      primaryColor = colors.greyTertiary
      secondaryColor = colors.greySecondary
    break
    case 'greyLightSecondary':
      fontColor = colors.greyDarkPrimary
      headerColor = colors.greyPrimary
      primaryColor = colors.greyLightSecondary
      secondaryColor = colors.greySecondary
    break
    case 'greyDarkSecondary':
      fontColor = colors.greyLightTertiary
      headerColor = colors.greyLightTertiary
      primaryColor = colors.greyDarkSecondary
      secondaryColor = colors.greyDarkPrimary
    break
    case 'greyDarkPrimary':
      fontColor = colors.greyLightTertiary
      headerColor = colors.greyLightTertiary
      primaryColor = colors.greyDarkPrimary
      secondaryColor = colors.greyDarkSecondary
    break
    case 'greySecondary':
      fontColor = colors.greyLightTertiary
      headerColor = colors.greyLightTertiary
      primaryColor = colors.greySecondary
      secondaryColor = colors.greyPrimary
    break
    case 'transparent':
      fontColor = colors.greyLightTertiary
      headerColor = colors.greyPrimary
      primaryColor = colors.greyPrimary
      secondaryColor = colors.greySecondary
    break
    case 'blueDarkSecondary':
    default:
      fontColor = colors.greyLightTertiary
      headerColor = colors.greyLightTertiary
      primaryColor = colors.blueDarkSecondary
      secondaryColor = colors.blueDarkPrimary
    break
  }

  return { fontColor, headerColor, primaryColor, secondaryColor }
}
// #endregion

// #region | Field Types
/* eslint-disable */
export enum NewFieldTypes {
  primaryField = "primaryField",
  secondaryField = "secondaryField",
  tertiaryField = "tertiaryField",
  tableHeaderCell = "tableHeaderCell"
}
/* eslint-enable */

export const CreateNewFieldType = (fieldType?:NewFieldTypes|string) => {
  let height: number
  let containerPaddingTop: number
  let containerPaddingRight: number
  let containerPaddingBottom: number
  let containerPaddingLeft: number
  let indicatorPadding: number
  let indicatorSeparatorDisplay: string
  let placeholderDisplay: string
  let dropdownIndicator: string

  switch (fieldType) {
    case NewFieldTypes.secondaryField:
      height = 30
      indicatorPadding = 5
      indicatorSeparatorDisplay = "none"
      placeholderDisplay = "block"
      dropdownIndicator = "block"
      containerPaddingTop = 2
      containerPaddingRight = 5
      containerPaddingBottom = 2
      containerPaddingLeft = 5
    break;
    case NewFieldTypes.tertiaryField:
      height = 25
      indicatorPadding = 5
      indicatorSeparatorDisplay = "none"
      placeholderDisplay = "block"
      dropdownIndicator = "block"
      containerPaddingTop = 2
      containerPaddingRight = 5
      containerPaddingBottom = 2
      containerPaddingLeft = 5
    break;
    case NewFieldTypes.tableHeaderCell:
      height = 25
      indicatorPadding = 0
      indicatorSeparatorDisplay = "none"
      placeholderDisplay = "none"
      dropdownIndicator = "none"
      containerPaddingTop = 2
      containerPaddingRight = 5
      containerPaddingBottom = 2
      containerPaddingLeft = 5
    break;
    case NewFieldTypes.primaryField:
    default:
      height = 30
      indicatorPadding = 8
      indicatorSeparatorDisplay = "block"
      placeholderDisplay = "block"
      dropdownIndicator = "block"
      containerPaddingTop = 2
      containerPaddingRight = 8
      containerPaddingBottom = 2
      containerPaddingLeft = 8
    break;
  }

  return { containerPaddingTop, containerPaddingRight, containerPaddingBottom, containerPaddingLeft, height, indicatorPadding, indicatorSeparatorDisplay, dropdownIndicator, placeholderDisplay }
}

// #endregion